import LArtwork, { LArtworkProps } from "@components/LArtwork";
import { theme } from "@theme";
import { SCREEN_WIDTH } from "../../config";
import SkeletonPlaceholder from "react-native-skeleton-placeholder";
import {
  LOADING_SHIMMER_SPEED,
  LOADING_SHIMMER_BG_COLOR,
  LOADING_SHIMMER_HIGHLIGHT_COLOR,
} from "../../config";
import LBox from "@components/LBox";
import LiveRoom from "@components/Accesses/AccessDetails/components/details/LiveRoom";
import { ExclusiveRibbon } from "@libs/shared-ui/native";

type HeroProps = {
  url: string | null;
  accessId?: string;
  // Exclusive songs carry the VIP corner, matching the LIB access sheet.
  showExclusiveRibbon?: boolean;
} & LArtworkProps;

const SIZE = SCREEN_WIDTH - theme.spacing.s4 * 2;
const BORDER_RADIUS = "m";

const Hero = ({ url, accessId, showExclusiveRibbon, ...props }: HeroProps) => {
  return (
    <LBox borderRadius={BORDER_RADIUS} overflow="hidden">
      <LArtwork url={url} size={SIZE} borderRadius={BORDER_RADIUS} {...props} />
      {showExclusiveRibbon ? <ExclusiveRibbon variant="featured" /> : null}
      {accessId ? <LiveRoom accessId={accessId} /> : null}
    </LBox>
  );
};

const Loading = () => {
  return (
    <SkeletonPlaceholder
      highlightColor={LOADING_SHIMMER_HIGHLIGHT_COLOR}
      backgroundColor={LOADING_SHIMMER_BG_COLOR}
      speed={LOADING_SHIMMER_SPEED}
      borderRadius={theme.borderRadii[BORDER_RADIUS]}
    >
      <SkeletonPlaceholder.Item width={SIZE} height={SIZE} />
    </SkeletonPlaceholder>
  );
};

export default {
  Hero,
  Loading,
};
